import { useQuery } from "react-query"
import { request } from "../util/request"
import { getPreviewTokenFromUrl } from "../util/previewToken"

export function useRelatedPosts(postId, page = 1, perPage = 5) {
  const previewToken = getPreviewTokenFromUrl()
  return useQuery(
    ["related_posts", postId, page, perPage, previewToken],
    () =>
      request({
        queryKey: [
          "related_posts",
          {
            path: `/api/v1/posts/${postId}/related_posts`,
            options: { method: "GET" },
            params: { page, per_page: perPage, preview_token: previewToken },
          },
        ],
      }),
    {
      keepPreviousData: true,
      enabled: !!postId, // Only fetch if postId is provided
    },
  )
}
